import React, {useRef, useEffect, useState} from 'react';
import {css} from 'emotion';
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';
import Input from '../../common/material-easy-ui/input/Input';
import UserAPI from '../../../api/UserAPI';
import ModalValid from '../../common/modal-valid';
import history from '../../../utils/history';

const ModalForgetPassword = props => {
  const refModal = useRef(null);
  const [email, setEmail] = useState('');
  const [error_pwdForget, setError_pwdForget] = useState(false);
  const [showModalValid, setShowModalValid] = useState(false);

  useEffect(() => {
    disableBodyScroll(refModal);
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  const onCloseModalValid = () => {
    setShowModalValid(false);
  };

  const onSendEmail = () => {
    setError_pwdForget(false);
    UserAPI.sendEmail(email)
      .then(() => {
        setShowModalValid(true);
      })
      .catch(error => {
        setError_pwdForget({
          error: true,
          message: error.response.data.error.details,
        });
      });
  };

  const goToCreateAccount = () => {
    history.push({pathname: '/signin'});
  };

  return (
    <div
      onClick={e => {
        props.onCloseModal();
      }}
      ref={refModal}
      className={css`
        top: 0px;
        left: 0px;
        position: fixed;
        z-index: 100;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
      `}>
      <div
        onClick={e => {
          e.stopPropagation();
        }}
        className={css`
          visibility: ${showModalValid ? 'hidden' : 'visible'};
          padding-bottom: 10px;
          background-color: white;
          border-radius: 10px;
          width: 300px;
          height: 250px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-left: 20px;
          padding-right: 20px;
        `}>
        <div
          className={css`
            color: grey;
            margin-top: 30px;
            font-size: 13px;
            text-align: center;
          `}>
          Pour réinitialiser votre mot de passe veuillez saisir l'adresse email
          de votre compte
        </div>

          <Input
            onChangeText={e => {
              setEmail(e.target.value);
            }}
            type={'text'}
            label={'email'}
            error={error_pwdForget}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              width: '80%',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
          />

        <div
          className={css`
            margin-top: 20px;
          `}>
          <div
            onClick={onSendEmail}
            className={css`
              &:hover {
                background-color: #5c9ebf;
              }
              cursor: pointer;
              background-color: #0085c6;
              color: white;
              padding-left: 10px;
              padding-right: 10px;
              box-sizing: border-box;
              padding-top: 5px;
              padding-bottom: 5px;
              margin-top: 10px;
              border-radius: 5px;
              width: 100%;
            `}>
            Envoyer
          </div>
        </div>
        <div
          className={css`
            margin-top: 20px;
            font-size: 13px;
            text-align: center;
            color: grey;
          `}>
          Si vous ne possedez toujours pas un compte veuillez{' '}
          <span
            onClick={goToCreateAccount}
            className={css`
              cursor: pointer;
              color: #0085c6;
              &:hover {
                text-decoration: underline;
              }
            `}>
            créez en un ici
          </span>
        </div>
      </div>
      {showModalValid && (
        <ModalValid
          message={'Un email vous a été envoyé'}
          onClose={onCloseModalValid}
        />
      )}
    </div>
  );
};

export default ModalForgetPassword;
